var video = document.getElementById("myVideo");
var btn = document.getElementById("myVideo");
var video2 = document.getElementById("myVideo2");
var video3 = document.getElementById("myVideo3");

function myFunction() {
    if (video.paused) {
        video.play();
        btn.classList.toggle('play');
    } else {
        video.pause();
        btn.classList.toggle('play');
    }
}

function myFunction2() {
    if (video2.paused) {
        video2.play();
        btn.classList.toggle('play');
    } else {
        video2.pause();
        btn.classList.toggle('play');
    }
}

function myFunction3() {
    if (video3.paused) {
        video3.play();
        btn.classList.toggle('play');
    } else {
        video3.pause();
        btn.classList.toggle('play');
    }
}